import { render, staticRenderFns } from "./VComment.vue?vue&type=template&id=3fb61b86&scoped=true"
import script from "./VComment.vue?vue&type=script&lang=js"
export * from "./VComment.vue?vue&type=script&lang=js"
import style0 from "./VComment.vue?vue&type=style&index=0&id=3fb61b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb61b86",
  null
  
)

export default component.exports